import { render, staticRenderFns } from "./CPBuySell.vue?vue&type=template&id=2bb31202&scoped=true&"
import script from "./CPBuySell.vue?vue&type=script&lang=ts&"
export * from "./CPBuySell.vue?vue&type=script&lang=ts&"
import style0 from "./CPBuySell.vue?vue&type=style&index=0&id=2bb31202&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb31202",
  null
  
)

export default component.exports